import React from 'react';
import SectionTemplates from './steps/SectionTemplates';
import Data from './steps/Data';
import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import {
  DATA,
  FINALIZE,
  SECTION,
  SECTION_TEMPLATES,
  SitrepSectionStepLabel,
} from './types';
import Section from './steps/Section';
import Finalize from './steps/Finalize';

const STEP_TO_COMPONENT_MAP: Record<SitrepSectionStepLabel, React.ReactNode> = {
  [SECTION_TEMPLATES]: <SectionTemplates />,
  [SECTION]: <Section />,
  [DATA]: <Data />,
  [FINALIZE]: <Finalize />,
};

/** This component renders the currently active step */
const SitrepSectionWizardContent = () => {
  const { activeStep } = useSitrepSectionWizardContext();

  return (
    <div className="sidebar-content p-3">
      {STEP_TO_COMPONENT_MAP[activeStep.label]}
    </div>
  );
};

export default SitrepSectionWizardContent;
